export default __webpack_public_path__ + "static/media/payment-auth-en-dark.c74c2ad4.png";